import axios from 'axios';

const API_BASE = '/api/kiosk';

export const kioskService = {
  getAnnouncements: async () => {
    const res = await axios.get(`${API_BASE}/announcements`);
    return res.data?.data ?? res.data;
  }
};
